import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { UserService } from '../../user/services/user.service';
import { Oauth2Service } from './oauth2.service';
import { SessionService, SessionState } from './session.service';
import { TokenStorageService } from './token-storage.service';
import { DefaultResponse } from '../../../interfaces/responses';

@Injectable({
  providedIn: 'root',
})
export class AuthFacadeService {
  private readonly _userService = inject(UserService);
  private readonly _oauth2Service = inject(Oauth2Service);
  private readonly _sessionService = inject(SessionService);
  private readonly _tokenStorage = inject(TokenStorageService);

  readonly user$ = this._userService.user$;
  readonly isLoggedIn$ = this._userService.isLoggedIn$;
  readonly sessionState$ = this._sessionService.sessionState$;
  readonly isAuthenticated$ = this._sessionService.isAuthenticated$;
  readonly isRestoring$ = this._sessionService.isRestoring$;

  isAuthenticated(): boolean {
    return this._userService.isLoggedIn();
  }

  getSessionState(): SessionState {
    return this._sessionService.getSessionState();
  }

  getCurrentUser() {
    return this._userService.getCurrentUser();
  }

  async tryRestoreSession(): Promise<void> {
    return this._sessionService.tryRestoreSession();
  }

  logout(): Observable<DefaultResponse<boolean>> {
    return this._userService.logout().pipe(
      tap(() => this._sessionService.clearSession())
    );
  }

  getTokenInfo() {
    return this._oauth2Service.getTokenInfo();
  }

  clearSession(): void {
    this._sessionService.clearSession();
  }
}